
export const getLSBoolean = (key, returnIfKeyNotFound) => {
  if (!key) return returnIfKeyNotFound
  const lSValue = localStorage.getItem(key)
  if (!lSValue) return returnIfKeyNotFound
  else return lSValue.toLowerCase() === 'false' ? false : Boolean(lSValue)
}
